import { BarChart } from '@mui/x-charts/BarChart';

interface Dataset {
  newUser: number;
  day: string;
}

interface Props {
  ResponseDataset: Dataset[]; // Expecting dataset as a prop
}

const BarChartDisplay: React.FC<Props> = ({ ResponseDataset }) => {

  const chartSetting = {
    yAxis: [{ label: 'New Student' }],
    borderRadius: 10,
    
  };

  // Create a map for quick lookup
  const dayMap = new Map(ResponseDataset.map(item => [item.day, item.newUser]));

  // Define the required days in order
  const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

  // Generate dataset efficiently
  const dataset = days.map(day => ({
    day: day === "Thursday" ? "TH" : (day === "Saturday" ? "SAT" : day.substring(0, 1)), // "Th" for Thursday, first letter otherwise
    newUser: dayMap.get(day) ?? 0, // Default to 0 if day is missing
  }));

  return (
      <BarChart
        dataset={dataset}
        xAxis={[{ scaleType: 'band', dataKey: 'day' }]}
        series={[{ dataKey: 'newUser', color: "#8A77CD" }]}
        {...chartSetting}
      />
  );
}

export default BarChartDisplay;
